var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { EyeIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { useNavigate } from "react-router-dom";
import { WPQTIconButton } from "../../../../components/common/Button/Button";
import { getOverviewRequest } from "../../../api/user-page-api";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
import { PageContentWrap, PageWrap } from "../Page/Page";
function HomePage() {
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const [loading, setLoading] = useState(true);
    const [overview, setOverview] = useState(null);
    const navigate = useNavigate();
    const { handleError } = useErrorHandler();
    useEffect(() => {
        getOverviewData();
    }, []);
    const getOverviewData = () => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            const response = yield getOverviewRequest(pageHash);
            setOverview(response.data);
        }
        catch (error) {
            handleError(error);
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsx(PageWrap, { loading: loading, onRefresh: getOverviewData, className: "wpqt-flex wpqt-items-center wpqt-justify-center", children: _jsx(PageContentWrap, { children: _jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-justify-center wpqt-gap-2", children: [_jsxs("div", { children: [__("Assigned tasks:", "quicktasker"), " ", overview === null || overview === void 0 ? void 0 : overview.assignedTasksCount] }), _jsx(WPQTIconButton, { icon: _jsx(EyeIcon, { className: "wpqt-size-5 wpqt-icon-blue" }), text: __("View assigned tasks", "quicktasker"), className: "wpqt-mb-5", onClick: () => navigate("/user-tasks") }), _jsxs("div", { children: [__("Assignable tasks:", "quicktasker"), " ", overview === null || overview === void 0 ? void 0 : overview.assignableTaskCount] }), _jsx(WPQTIconButton, { icon: _jsx(EyeIcon, { className: "wpqt-size-5 wpqt-icon-green" }), text: __("View assignable tasks", "quicktasker"), onClick: () => navigate("/assignable-tasks") })] }) }) }));
}
export { HomePage };
